import { forwardRef, type TextareaHTMLAttributes } from 'react';
import type { FieldName } from './fieldLabel';

export type TextareaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'aria-label' | 'aria-labelledby' | 'id'> &
  FieldName & {
    id?: string;
  };

/** Multi-line text input primitive. Inherits the shared form chrome; always named (FieldName). */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className = '', ...props },
  ref
) {
  return (
    <textarea
      ref={ref}
      className={['textarea', 'bk-control', className].filter(Boolean).join(' ')}
      {...props}
    />
  );
});
